import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { NameDto } from "../../api/models/name-dto";
import { HousingService } from "../../api/services/housing.service";

@Injectable({
  providedIn: "root",
})
export class HousingsResolver implements Resolve<Array<NameDto>> {
  constructor(private housingService: HousingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<NameDto>> {
    return this.housingService.housingControllerFindAllDropdown({ initial: false });
  }
}
